import { useQuery } from '@tanstack/react-query';

import { NotifyService } from '../../api/NotifyAPI';
import { useAuth } from '../../store';
import { usePagination } from '../../utils';
import { Pagination } from '../Pagination/Pagination';
import s from '../../styles/staff.module.css';

// Table of notifications the logged-in user has SENT. The server derives the
// sender from the bearer token, so GET /notify returns only this user's sent
// notifications. Rendered inside the Staff page beneath the staff table.
export function NotifyTable() {
  const { user } = useAuth();

  const { data, isLoading } = useQuery({
    queryKey: ['notify-sent'],
    queryFn:  () => NotifyService.sent(),
    enabled:  !!user,
  });

  const notifications = data?.notifications || [];
  const { page, pageCount, pageItems, setPage } = usePagination(notifications, 10);

  return (
    <div className={s.notifyTable}>
      <div className={s.sectionLabel}>Sent Notifications ({notifications.length})</div>
      <div className={s.tableWrap}>
        <table className={s.table}>
          <thead>
            <tr>
              <th>Date</th>
              <th>To (staff #)</th>
              <th>Message</th>
              <th>Status</th>
            </tr>
          </thead>
          <tbody>
            {isLoading && (
              <tr><td colSpan={4} className={s.loading}>Loading…</td></tr>
            )}
            {!isLoading && notifications.length === 0 && (
              <tr><td colSpan={4} className={s.empty}>No notifications sent yet</td></tr>
            )}
            {!isLoading && pageItems.map((n) => (
              <tr key={n.idNotify}>
                <td>{new Date(n.dateCreated).toLocaleString()}</td>
                <td>{n.receiverFirstName} {n.receiverLastName}</td>
                <td>{n.message}</td>
                <td>{n.status}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <Pagination page={page} pageCount={pageCount} onPage={setPage} />
    </div>
  );
}
